import React, { useCallback, useContext, useEffect, useState } from 'react';
import AuthContext from './components/authcontext/AuthContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ManageProperty from './components/pages/ManageProperty';
import LoginPage from './components/common/LoginPage';
import LoginModal from './components/common/LoginModal';
import AgentLogin from './components/common/AgentLogin';
import Register from './components/common/Register';
import Header from './components/layout/Header';
import Landing from './components/pages/Landing';
import UnAuth from './components/common/UnAuth';
import Dashboard from './components/pages/dashboard/Dashboard';
import UserDashboard from './components/pages/dashboard/UserDashBoard'
import BiddingPage from './components/pages/bidding/BiddingPage';
import AboutUs from './components/pages/AboutUs';
import PropertyListing from './components/pages/PropertyListing';
// import Cart from './components/pages/Cart';
import BiddingList from './components/pages/BiddingList';
import Loading from './components/common/Loading';
import axiosInstance from './utils/axiosInstance';
import axios from 'axios';
import { config } from './utils/config';
import CommonModal from './components/common/CommonModal';

function App() {

  const authData = useContext(AuthContext);
  const [countdownPopup, setCountdownPopup] = useState(false)

  useEffect(() => {

    const refresh = async () => {
      try {

        // get Access Token
        const response = await axios.post(`${config.apiBaseUrl}/user-login/refresh`, {}, { withCredentials: true })
        const getAccessToken = response.data.accessToken
        console.log("****new Access Token:", getAccessToken)
        authData.updateToken(getAccessToken)


        if (getAccessToken) {
          const userData = await axios.get(`${config.apiBaseUrl}/user-login/profile`, {
            headers: {
              'Authorization': `Bearer ${getAccessToken}`
            }
          }, { withCredentials: true });
          authData.updateUserDetail(userData.data)
          console.log("refreshed", userData.data)

          if (getAccessToken && userData.data.ceaNo) {
            await authData.updateIsAgentAuth(true)
            authData.updateFinishedLoading(true)

          } else if (getAccessToken && userData.data.username) {
            await authData.updateIsAuth(true)
            authData.updateFinishedLoading(true)

          } else {
            console.log("unable to authenticate as no access token or user details are found")
            authData.updateFinishedLoading(true)
          }

        } else {
          console.log("unable to authenticate or please log in again as no refresh token or access token are found")
          authData.updateFinishedLoading(true)
        }

      } catch (error) {
        console.error(error)

      } finally {
        authData.updateFinishedLoading(true);
      }
    }
    refresh()
    
    // eslint-disable-next-line
  }, [])

  const getClientToken = useCallback(async () => {

    const clientToken = await axios.get(`${config.apiBaseUrl}/user/client/token`, { withCredentials: true })
    // console.log("clientToken App.js", clientToken.data)

    if (clientToken && clientToken.data !== "client not registered") {
      const token = clientToken.data.clientToken
      authData.updateClientToken(token)
      console.log("clientToken App.js", token)
      const timerId = setTimeout(() => {
        // Show the popup after 14 minutes
        setCountdownPopup(true);
      }, 840000); // 900000 milliseconds = 15 minutes

      // Clear timeout on component unmount
      return () => clearTimeout(timerId);

    } else {
      console.log("no bid token found as user did not register")
    }

  }, [])


  useEffect(() => {

    getClientToken()
    
  },[getClientToken])


  return (
    <>
      {!authData.getFinishedLoading() ?
        <Loading />
        :
        <Router>
          <Header />

          <Routes>
            {/* <Route path='/' element={<Landing />} /> */}
            {/* Display PropertyListing as the main page */}
            <Route path='/' element={<PropertyListing />} /> 
            <Route path='/aboutus' element={<AboutUs />} />
            <Route path='/propertylisting' element={<PropertyListing />} />
            <Route path='/bidding' element={authData.getIsAgentAuth() ? <UnAuth /> : <BiddingList />} />
            <Route path='/bidding/:biddingId' element={<BiddingPage />} />
            {/* <Route path='/cart' element={authData.getIsAgentAuth() ? <UnAuth/> : <Cart />} /> */}
            <Route path='/agent/login' element={<AgentLogin />} />
            <Route path='/register' element={<Register />} />
            <Route path='/login' element={authData.getIsAuth() || authData.getIsAgentAuth() ? null : <LoginPage />} />
            <Route path='/user/login' element={authData.getIsAuth() || authData.getIsAgentAuth() ? null : <LoginModal />} />
            <Route path='/user/dashboard' element={authData.getIsAuth() ? <UserDashboard /> : <UnAuth />} />
            <Route path='/agent/dashboard' element={authData.getIsAgentAuth() ? <Dashboard /> : <UnAuth />} />
            <Route path='/property/:lid' element={authData.getIsAgentAuth() || authData.getIsAuth() ? <ManageProperty /> : <UnAuth />} />
          </Routes>

          <div className='container'>
            <h6>CopyRight 2023</h6>
          </div>
        </Router>
      }
      <CommonModal title="Session Expiring" message="To stay on to bid, please click continue. Otherwise, please proceed to logout" show={countdownPopup}
        footer={<div className="d-flex justify-content-between"><button className="btn btn danger" onClick={() => { getClientToken() ; setCountdownPopup(false) }}>Continue</button>
          <button onClick={() => { setCountdownPopup(false) }}>End Bidding</button>
        </div>} handleClose={() => { setCountdownPopup(false); }} />
    </>
  );
}

export default App;
